/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'search': {
    width: 16,
    height: 16,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M31.64 29.79c.24.26.36.57.36.92 0 .36-.12.67-.36.93-.26.24-.57.36-.93.36-.35 0-.65-.12-.89-.36l-7.36-7.35a13.39 13.39 0 01-8.75 3.14c-3.78 0-7.01-1.34-9.7-4.02A13.21 13.21 0 010 13.71c0-3.78 1.34-7.01 4.02-9.7A13.21 13.21 0 0113.72 0c3.78 0 7.01 1.34 9.7 4.02a13.21 13.21 0 014 9.7c0 3.28-1.04 6.2-3.13 8.74l7.35 7.33zM18.04 24A11.25 11.25 0 0024 9.4 11.25 11.25 0 009.4 3.42 11.25 11.25 0 002.56 13.7c0 1.53.3 2.97.9 4.33A11.25 11.25 0 009.4 24c1.35.57 2.79.86 4.31.86 1.53 0 2.97-.29 4.33-.86z"/>'
  }
})
